import React from "react";
import moment from "moment";
import { permissions } from "../../../config/permissions";
import { checkPermission } from "../../../config/utils";

const DocumentAndImageItem = ({
    doc,
    index,
    uploadOrEditDocument,
    handleDeleteUserDocs,
    handleShowDocPreview,
    downloadDocs,
    provided,
    isImage,
    tabName,
    viewImage,
    ...props
}) => {
    return (
        <div
            class={`drag-item ${doc?.doc_type === "GLB" ? "global-doc" : ""}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            key={`draggable-${index}`}
        >
            <div class="top-sec">
                <div class="icon">
                    <img src="/img/icon-squre.svg" alt="" />
                </div>
                <div class="right-smchart-sec d-flex">
                    {checkPermission("forms", permissions.SMART_CHARTS, "edit") && (
                        <div
                            class="del-icn mr-2 edit-icon"
                            data-tip={
                                tabName === "Image"
                                    ? "Edit Image Caption"
                                    : tabName === "Document"
                                    ? "Edit Document Name & Template"
                                    : `Edit ${tabName} Name`
                            }
                            data-for="table-top-icons-grid"
                            onClick={() => uploadOrEditDocument(doc)}
                        >
                            <img src="/img/edit-pen-icon.svg" alt="" />
                        </div>
                    )}
                    {checkPermission("forms", permissions.SMART_CHARTS, "delete") && (
                        <div
                            class="del-icn mr-2 edit-icon"
                            data-tip={`Delete ${tabName}`}
                            data-for="table-top-icons-grid"
                            onClick={() => handleDeleteUserDocs(doc.id)}
                        >
                            <img src="/img/delete-sm-chrt.svg" alt="" />
                        </div>
                    )}
                    {!isImage && checkPermission("forms", permissions.SMART_CHARTS, "export") ? (
                        <div
                            class="del-icn mr-2 edit-icon"
                            data-tip="Download Document"
                            data-for="table-top-icons-grid"
                            onClick={() => downloadDocs(doc.s3_file)}
                        >
                            <img src="/img/download.svg" alt="" />
                        </div>
                    ) : null}

                    <div
                        class="del-icn mr-2 edit-icon"
                        data-tip="View Preview"
                        data-for="table-top-icons-grid"
                        onClick={() => handleShowDocPreview(doc.id)}
                    >
                        <img src="/img/eye-ico-ic.svg" alt="" />
                    </div>
                </div>
            </div>
            {isImage && doc.is_image ? (
                <div class="cont-sec flex-wrap flex-column">
                    <div class="img-sec" onClick={() => viewImage(doc?.gallery_image?.image_file)}>
                        <img src={doc?.gallery_image?.image_file} alt="" />
                    </div>
                    <div class="img-name">{doc.name || doc?.gallery_image?.caption || "-"}</div>
                </div>
            ) : (
                <div class="cont-sec">
                    <div class="icons-sec">
                        <img src="/img/file-type-standard.svg" alt="" />
                    </div>
                    <h3>{doc.name || "-"}</h3>
                </div>
            )}
            {!isImage ? (
                <>
                    <div class="notes-cont type-sec mt-1">
                        <label>File Name</label>
                        <div class="content-dtl">{doc?.file_name || "-"}</div>
                    </div>
                    <div class="notes-cont type-sec mt-1">
                        <label>Type</label>
                        <div class="content-dtl">{doc?.doc_type === "GLB" ? "Global Document" : "Client Document"}</div>
                    </div>
                </>
            ) : null}
            <div class="notes-cont">
                <label>Notes</label>
                <div class="content-dtl">{doc.notes || "-"}</div>
            </div>
            <div class="fot-sec top-border mt-0">
                <div class="fot-select">
                    <label>Uploaded By</label>
                    <div class="upl-cont">{doc.user || "-"}</div>
                </div>
                <div class="fot-select">
                    <label>Uploaded On</label>
                    <div class="upl-cont">{doc.created_at ? moment(doc.created_at).format("MM-DD-YYYY h:mm A") : "-"}</div>
                </div>
            </div>
            {provided.placeholder}
        </div>
    );
};
export default DocumentAndImageItem;
